import { AxiosError, AxiosResponse } from "axios";
import { companyClient } from "api/api";
import { IAppointmentType } from "../types/IAppointmentType";

export const getAppointmentTypesWithDefaults = async () => {
  const onSuccess = (response: AxiosResponse) => {
    return response.data.sort((a: IAppointmentType, b: IAppointmentType) =>
      a.label.localeCompare(b.label)
    );
  };

  const onError = (error: AxiosError) => {
    console.error(error);
    return [];
  };

  return companyClient({
    method: "GET",
    url: "/appointment-types/with-defaults",
  })
    .then(onSuccess)
    .catch(onError);
};
